import { Component } from '@angular/core';

/** The apple logo */
@Component({
  selector: 'io-provetech-apple-logo',
  templateUrl: '../../assets/apple-logo.svg',
  styles: ['']
})
export class AppleLogoSvg {}
